import { RootState } from '../store'

export const notesSelector = (state: RootState) => {
  const { notes } = state

  return notes
}
